<template>
    <div>
        <m-loader size="box" :show="Object.keys(states).length === 0" />
        <b-row class="justify-content-md-center">
            <b-col xl="5" lg="5" md="5" sm="6" class="left-title">
                <h4 class="mt-2">Available States:</h4>
            </b-col>
            <b-col xl="5" lg="5" md="5" sm="6" class="right-select"><b-form-checkbox @change="checkAllState($event)">Select
                    All</b-form-checkbox></b-col>
        </b-row>
        <b-row align-h="center">
            <b-col align-self="center" xl="10" lg="10" md="10" sm="12">
                <div class="card state-box">
                    <b-form-checkbox-group v-model="getSelectedList" name="flavour-2a" stacked>
                        <b-form-checkbox v-for="state in states" @change="toggleGeo(state)" class="select-checkbox" :value="state"
                            :key="state.code">{{ state.name }}</b-form-checkbox>
                    </b-form-checkbox-group>
                </div>
            </b-col>
        </b-row>
    </div>
</template>
  
<script>
export default {
    data() {
        return {
            selectedSubtitle: [],
        }
    },
    props: {
        geoType: {
            type: Number
        },
        changeGeoType: {
            type: Number,
            default: 2
        }
    },
    created() {
        this.$store.dispatch('geo/getStates')
    },
    computed: {
        realgeoType() {
            return this.$store.state.geo.geoTypes.State
        },
        states() {
            return this.$store.state.geo.states
        },
        getSelectedList: {
            get() {
                let orderGeos = this.$store.state.order.OrderGeos
                return orderGeos.map(item => { return { code: item.GeoKeyCode, name: item.GeoKeyDesc, country: "US" } })
            },
            set(val) {
            }
        }
    },
    methods: {
        getIsSelected(code) {
            let orderGeos = this.$store.state.order.OrderGeos
            for (let key of Object.keys(orderGeos)) {
                if (code === orderGeos[key].GeoKeyCode) {
                    return true
                }
            }
            return false
        },
        toggleGeo(item) {
            console.log(this.changeGeoType)
            if (this.getIsSelected(item.code)) {
                this.$store.commit('order/deleteGeo', item.code)
            } else {
                this.$store.dispatch('order/changeGeoType', this.changeGeoType)
                this.$store.commit('order/addGeo', {
                    GeoKeyCode: item.code,
                    GeoKeyDesc: item.name,
                    GeoType: 2
                })
            }
        },
        checkAllState(event) {
            if (event) {
                this.$store.dispatch('order/changeGeoType', this.changeGeoType)
                for (let state in this.$store.state.geo.states) {
                    let s = this.$store.state.geo.states[state]
                    this.$store.commit('order/addGeo', {
                        GeoKeyCode: s.code,
                        GeoKeyDesc: s.name,
                        GeoType: 2
                    })
                }
            } else {
                this.$store.commit('order/cleanGeo')
            }
        }
    }
}
</script>
  
<style scoped lang="scss">
.left-title {}

.right-select {
    text-align: right;
}

.state-box {
    width: 100%;
    height: 460px;
    overflow-y: auto;
    padding: 16px;
}
</style>
  
  


// WEBPACK FOOTER //
// src/components/geo/MGeoState.vue